import { useMutation, useQueryClient } from '@tanstack/react-query'

import { deleteShipmentOrderHistory } from '../api/delete-shipment-order-history'
import { shipmentOrderHistoriesQueryKeys } from '../query-keys'

type DeleteHistoryParams = {
  tenantKey: string
  id: number
}

/**
 * 配送依頼入力履歴削除Mutation
 */
export const useDeleteShipmentOrderHistoryMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ tenantKey, id }: DeleteHistoryParams) => {
      return deleteShipmentOrderHistory({ tenantKey, id })
    },
    onSuccess: (_, variables) => {
      // selectクエリのキャッシュを無効化
      queryClient.invalidateQueries({
        queryKey: shipmentOrderHistoriesQueryKeys.select(variables.tenantKey)
      })
    },
    onError: (error) => {
      console.error('Failed to delete history:', error)
    }
  })
}
